import { useState, useEffect } from "react";
import { apiRequest } from "../utils/api";

function useFechBuyline(localStorageKey) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorageKey) {
      console.error("LocalStorageKey are required.");
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await apiRequest.get(`/buyline/enable-status`);

        // Example logic: Store `true` if API returns data, `false` otherwise
        const valueToStore =
          response.data.message.buyline_enable == "true" ? true : false;
        localStorage.setItem(localStorageKey, JSON.stringify(valueToStore));
        setData(valueToStore);
      } catch (err) {
        setError(err);
        localStorage.setItem(localStorageKey, JSON.stringify(false)); // Store `false` on error
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [localStorageKey]);

  return { data, error, loading };
}

export default useFechBuyline;
